import { render, staticRenderFns } from "./TheHomeFbBusinessPage.vue?vue&type=template&id=623da198&scoped=true"
import script from "./TheHomeFbBusinessPage.vue?vue&type=script&lang=js"
export * from "./TheHomeFbBusinessPage.vue?vue&type=script&lang=js"
import style0 from "./TheHomeFbBusinessPage.vue?vue&type=style&index=0&id=623da198&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "623da198",
  null
  
)

export default component.exports